// Convert a monetary value, represented by a string, into an integer representing the equivalent amount of cents
function moneyToCents(
  money: string,
): number {
  const centsString = parseFloat(money).toFixed(2).replace(".", "");
  const cents = parseInt(centsString);

  return cents;
}

export default moneyToCents;
